module.exports = __webpack_public_path__ + "static/questions-2478d594cacdfb88a8f4bba242599229.svg";